module.exports = __webpack_public_path__ + "assets/2d87877dce0e74a7a888b967a37949f5.mp3";